import { DataModules, IDataState } from "@/store/modules/data/index";
import { ActionTree, GetterTree } from "vuex";
import { IState } from "@/store";
import { ApiPathGetter } from "@/models/api";

const initialState = {} as IDataState;

const getters: GetterTree<IDataState, IState> = {
  apiPath: (s, g, rS, { isAdminContext }): ApiPathGetter => () => {
    const admin = "api/admin/statuses";
    const client = "api/statuses";
    const contextual = isAdminContext ? admin : client;
    return { client, admin, contextual };
  },
  scope: () => id => {
    return `$status${id}`;
  }
};

const actions: ActionTree<IDataState, IState> = {
  list: ({ dispatch, getters }, payload) => {
    return dispatch(
      "data/list",
      {
        ...payload,
        path: getters.apiPath().contextual,
        storeModule: DataModules.STATUSES
      },
      { root: true }
    );
  },
  listByType: ({ dispatch, getters }, payload) => {
    return dispatch(
      "data/list",
      {
        ...payload,
        params: {
          "filter[object_type]": payload.type
        },
        path: getters.apiPath().contextual,
        storeModule: DataModules.STATUSES
      },
      { root: true }
    );
  }
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions
};
